import {
  Audiogram,
  audiogramDefaultProps,
  AudiogramProps,
  audiogramSchema,
  calculateAudiogramMetadata,
} from '@mi-front/audiogram';
import { Player, PlayerProps } from '@remotion/player';
import { useEffect, useState } from 'react';
import { CalcMetadataReturnType } from 'remotion/dist/cjs/Composition';
import { AnyZodObject } from 'zod';

export const AudiogramPlayer: React.FC<{
  audiogramProps: Partial<AudiogramProps>;
  playerProps?: Partial<PlayerProps<AnyZodObject, AudiogramProps>>;
}> = (props) => {
  const [calculatedPlayerProps, setCalculatedPlayerProps] = useState<
    CalcMetadataReturnType<AudiogramProps> | undefined
  >();

  useEffect(() => {
    calculateAudiogramMetadata({ props: props.audiogramProps }).then(setCalculatedPlayerProps);
  }, [props.audiogramProps]);

  if (!calculatedPlayerProps) {
    return null;
  }

  const { durationInFrames, props: finalProps, fps } = calculatedPlayerProps;

  return (
    <div style={{ maxWidth: '100%' }}>
      <Player
        component={Audiogram}
        schema={audiogramSchema}
        durationInFrames={durationInFrames!}
        compositionWidth={finalProps!.variant === '16x9' ? 1920 : 1080}
        compositionHeight={finalProps!.variant === '9x16' ? 1920 : 1080}
        fps={fps!}
        inputProps={
          {
            ...audiogramDefaultProps,
            ...finalProps,
          } as AudiogramProps
        }
        style={{
          width: '100%',
          aspectRatio: finalProps!.variant?.replace('x', '/'),
        }}
        acknowledgeRemotionLicense
        controls
        {...props.playerProps}
      />
    </div>
  );
};
